import React, { useState, useEffect } from "react";
import { getAssetDataByID } from "../../Services/Games/gamesService";
import { getMediaUrl } from "../../utils/Api";

const PlaySound = ({ assetId }) => {
  const [preview, setPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAudio = async () => {
      setIsLoading(true);
      try {
        const response = await getAssetDataByID(assetId);
        console.log('response',response)
        if (response) {
          const audioUrl = `${getMediaUrl()}/${response?.data?.asset_file}`;
          const audioResponse = await fetch(audioUrl);
          const audioBlob = await audioResponse.blob();
          const audioBlobUrl = URL.createObjectURL(audioBlob);
          setPreview(audioBlobUrl);
        }
      } catch (error) {
        setPreview(null);
      }
      setIsLoading(false);
    };

    fetchAudio();

    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [assetId]);

  return (
    <>
      {isLoading && <p>Loading...</p>}
      {preview && (
        <div className="mt-3">
          <div className="audio-preview">
            <audio controls src={preview} controlsList="nodownload"/>
          </div>
        </div>
      )}
    </>
  );
};

export default PlaySound;
